import { render } from "./A106000.vue?vue&type=template&id=39774cee&scoped=true"
import script from "./A106000.vue?vue&type=script&lang=js"
export * from "./A106000.vue?vue&type=script&lang=js"

import "./A106000.vue?vue&type=style&index=0&id=39774cee&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39774cee"]])

export default __exports__